import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, InputGroup, Dropdown } from '@themesberg/react-bootstrap';
import Preloader from "../../components/Preloader"; // Path to your code above
import { DriversTable } from "../../../src/components/Tables";
import { use } from "react";
import { useState, useEffect } from "react";
import { getDriverDetails, getDriversList, setDriverSearch } from "../../api/services/";
import TmsPopup from "../../../src/components/Popup"; // Path to your code above
import DriverAddFrom from "../../pages/forms/DriverAddForm"

export default () => {
  const [drivers, setDrivers] = useState({});
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDriverAddWindow, setShowDriverAddWindow] = useState(false);
  // 🔹 Fetch drivers (TABLE)
  const fetchDrivers = async (page = 1, searchValue = search) => {
    try {
      console.log("API CALL → search:", searchValue);

      const data = await getDriversList({
        page,
        search: searchValue,
        page_size: pageSize,
      });

      setDrivers(data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Debounce input
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearch(searchInput);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchInput]);

  // 🔹 Fetch when search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchDrivers(1, search);
  }, [search]);

  // 🔹 Pagination
  useEffect(() => {
    fetchDrivers(currentPage, search);
  }, [currentPage, pageSize]);

  // 🔹 Suggestions
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!search || search.trim() === "") {
        setSuggestions([]);
        setShowDropdown(false);
        return;
      }

      try {
        const res = await getDriversList({
          page: 1,
          search,
          page_size: 5,
        });

        setSuggestions(res.drivers);
        setShowDropdown(true);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSuggestions();
  }, [search]);

  // 🔹 Select suggestion
  const handleSelect = (driver) => {
    const value = `${driver.first_name} ${driver.last_name}`;
    setSearchInput(value);
    setSearch(value);
    setShowDropdown(false);
  };

  // 🔹 Pagination click
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDriverClick = async (e) => {
    // setShowLoader(true);
    e.preventDefault();
    setShowDriverAddWindow(true);
    // try {
    //   history.push(Routes.Team_Driver.path);

    // }
    // catch (error) {
    //   console.log("Team Driver Navigation Error:", error);
    // } finally {
    //   setShowLoader(false);
    // } 
  };
  return (
    <>
      {/* <Preloader show={showLoader} /> */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>My Drivers</h4>
          <p className="mb-0">This is your drivers dashboard.</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">Upload</Button>
            <Button variant="outline-primary" size="sm">Sample</Button>
          </ButtonGroup>
        </div>
      </div>

      <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col xs={8} md={6} lg={3} xl={4}>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="text" placeholder="Search Drivers.."
                // type="text"
                className="form-control"
                // placeholder="Search driver..."
                value={searchInput}
                onChange={(e) => {
                  console.log("Typing:", e.target.value);
                  setSearchInput(e.target.value);
                }}
                onFocus={() => setShowDropdown(true)}
              />
              {/* {showDropdown && suggestions.length > 0 && (
                <div className="dropdown-menu show w-100">
                  {suggestions.map((driver, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      onClick={() => handleSelect(driver)}
                    >
                      {driver.first_name} {driver.last_name} ({driver.dl_num})
                    </div>
                  ))}
                </div>)} */}
            </InputGroup>
          </Col>
          {/* <Col xs={4} md={2} xl={3} className="ps-md-0 text-end">
            <Dropdown as={ButtonGroup}>
              <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-0">
                <span className="icon icon-sm icon-gray">
                  <FontAwesomeIcon icon={faCog} />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-right">
                <Dropdown.Item className="fw-bold text-dark">Show</Dropdown.Item>
                <Dropdown.Item className="d-flex fw-bold">
                  10 <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck} /></span>
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold">20</Dropdown.Item>
                <Dropdown.Item className="fw-bold">30</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col> */}
          <Col xs={8} md={6} xl={5} className="ps-md-0 text-end">
            <Button variant="secondary" className="text-dark me-3" onClick={handleDriverClick}>
              <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />  Add Driver </Button>
          </Col>
        </Row>
      </div>

      <TmsPopup show={showDriverAddWindow}
        handleClose={() => setShowDriverAddWindow(false)}
        title="Add Driver"
        onSave={() => {
          console.log("Save clicked");
          setShowDriverAddWindow(false);
        }}>
        <DriverAddFrom />
      </TmsPopup>

      {/* <DriversTable driversData={jsonData}  /> */}
      {/* <DriversTable driversResponse={drivers} /> */}
      <DriversTable
        driversResponse={drivers}
        onPageChange={handlePageChange}
        currentPage={currentPage}
      />
    </>
  );
};
